if (!window.TabSwitcher) {
  window.TabSwitcher = class TabSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabButtons = this.querySelectorAll('.tab-button');
      this.tabPanels = this.querySelectorAll('.tab-panel');

      this.tabButtons.forEach(button => {
        button.addEventListener('click', () => this.switchTab(button));
      });
    }

    switchTab(button) {
      this.tabButtons.forEach(btn => btn.classList.remove('active'));
      this.tabPanels.forEach(panel => panel.classList.remove('active'));

      button.classList.add('active');
      const tabPanel = this.querySelector(`[data-tab-panel="${button.dataset.tab}"]`);
      if (tabPanel) tabPanel.classList.add('active');
    }
  };
}

if (!customElements.get('tab-switcher')) {
  customElements.define('tab-switcher', window.TabSwitcher);
}
